import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {TextField} from '@mui/material';
import {useDebounce} from '../../_helpers';
import {BrickContext} from 'olympe';

/**
 * @param {CheckboxWithOptionsListOfPREditors.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
export function VendorCodeEditCell(props) {
    const initialValue = props.value || '';
    const [vendorCode, setVendorCode] = useState(initialValue);
    const debouncedVendorCode = useDebounce(vendorCode, 800);

    useEffect(() => {
        const fetchVendorName = async () => {
            try {
                const vendorNameResponse = await props.getVendorNameLambda(
                    props.context,
                    props.context.get('Get Vendor Name'),
                    debouncedVendorCode,
                );
                const vendorName =
                    Array.isArray(vendorNameResponse) && vendorNameResponse[0] !== null ?
                        vendorNameResponse[0] :
                        '';
                props.api.setEditCellValue({id: props.id, field: 'vendor_name', value: vendorName});
            } catch (error) {
                console.error('Error fetching vendor name:', error);
            }
        };

        if (debouncedVendorCode) {
            fetchVendorName();
        }
    }, [debouncedVendorCode, props.api, props.context, props.getVendorNameLambda, props.id]);

    const handleChange = (event) => {
        const newCode = event.target.value;
        setVendorCode(newCode);
        props.api.setEditCellValue({id: props.id, field: props.field, value: newCode});
    };

    return (
        <TextField
            value={vendorCode}
            onChange={handleChange}
            fullWidth
        />
    );
}

VendorCodeEditCell.propTypes = {
    api: PropTypes.object,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    field: PropTypes.string,
    value: PropTypes.any,
    getVendorNameLambda: PropTypes.func,
    context: PropTypes.instanceOf(BrickContext).isRequired,
};
